<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

		
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索等級名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->
				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="用戶名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="用戶名稱"></el-input>
						</el-form-item>

						<el-form-item label="用戶編號" class="mb-0">
							<el-input size="small" v-model="from.user_no" placeholder="用戶編號"></el-input>
						</el-form-item>

						<el-form-item label="內容" class="mb-0">
							<el-input size="small" v-model="from.content" placeholder="內容"></el-input>
						</el-form-item>

						<el-form-item label="有內容" class="mb-0">
							<el-select v-model="from.is_content" size="small" placeholder="請選擇類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="有內容" :value="1"></el-option>
								<el-option label="無內容" :value="2"></el-option>
							</el-select>
						</el-form-item>
					
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center"></el-table-column> -->
				<el-table-column align="center"  prop="user_no" label="編號">
				</el-table-column>
				<el-table-column align="center" prop="school_name" label="學校">
				</el-table-column>
				<el-table-column align="center" prop="grade_name" label="年級">
				</el-table-column>
				<el-table-column align="center" prop="name" label="姓名">
				</el-table-column>
                <el-table-column align="center" prop="status" label="編輯名片" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.status ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeUserStatus(scope.row)"
						plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="profile" label="簡介">
				</el-table-column>
				<el-table-column align="center" prop="book_heart" label="讀書心得">
				</el-table-column>
				<el-table-column align="center" prop="like_subject" label="喜歡科目">
				</el-table-column>
				<el-table-column align="center" prop="like_book" label="喜歡書籍">
				</el-table-column>
				<el-table-column align="center" prop="interest" label="興趣">
				</el-table-column>
				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改等級' : '添加等級'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'130px'">
				<el-form-item label="姓名" prop="level">
                    {{form.name}}
				</el-form-item>
				<el-form-item label="簡介" prop="profile">
					<el-input  v-model="form.profile" type="text" placeholder="簡介"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item label="讀書心得" prop="book_heart">
					<el-input  v-model="form.book_heart" type="text" placeholder="讀書心得"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item label="喜歡科目" prop="like_subject">
					<el-input  v-model="form.like_subject" type="text" placeholder="喜歡科目"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item label="喜歡書籍" prop="like_book">
					<el-input  v-model="form.like_book" type="text" placeholder="喜歡書籍"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item label="興趣" prop="interest">
					<el-input  v-model="form.interest" type="text" placeholder="興趣"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

		<!-- 用戶禁用彈窗 -->
		<el-dialog
			title="禁用用戶"
			:visible.sync="statusDialog.visible"
			width="500px"
			:close-on-click-modal="false"
			@close="closeStatusDialog"
		>
			<el-form :model="statusForm" :rules="statusRules" ref="statusForm" label-width="100px">
				<el-form-item label="用戶資訊">
					<div class="user-info">
						<p><strong>用戶ID:</strong> {{ statusForm.user_id }}</p>
						<p><strong>用戶名:</strong> {{ statusForm.name }}</p>
						<p><strong>當前狀態:</strong> 
							<el-tag :type="statusForm.current_status ? 'success' : 'danger'">
								{{ statusForm.current_status ? '啟用' : '禁用' }}
							</el-tag>
						</p>
					</div>
				</el-form-item>
				
				<el-form-item 
					label="禁用原因" 
					prop="reason" 
					:rules="[{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }]"
				>
					<el-input
						v-model="statusForm.reason"
						type="textarea"
						:rows="4"
						placeholder="請輸入禁用用戶的原因..."
						maxlength="500"
						show-word-limit
					></el-input>
				</el-form-item>
			</el-form>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeStatusDialog">取消</el-button>
				<el-button type="primary" @click="confirmStatusChange" :loading="statusDialog.loading">
					禁用
				</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name:'',
					is_content:-1,
					content:'',
					user_no:'',
				},
				model_title: 'UserInfo',
				auth_val: 'UserInfo',
				preUrl: "data/UserInfoList", //列表地址
				delAllUrl: "data/delUserInfoAll", //批量删除地址
				delUrl: "data/delUserInfo", //删除單条地址
				addUrl: "data/addUserInfo", //添加/修改地址
				editStatusUrl: "data/editStatusUserInfo", //添加/修改地址

				tableData: [],
				form: {
					id:0,
					level:0,
					name:'',
					up_score:0,
					send_diamond:0,
					send_coin:0,
				},
				rules: {
					

				},
				prop: 'update_time',
				sort: 'descending',
				subject_list: [],
				check_img_list:[],
				
				// 用戶狀態修改彈窗
				statusDialog: {
					visible: false,
					loading: false
				},
				statusForm: {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				},
				statusRules: {
					reason: [
						{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }
					]
				},
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
					}
				})
			},
			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						level:0,
						name:'',
						up_score:0,
						send_diamond:0,
						send_coin:0,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						name: e.row.name,
						profile: e.row.profile,
						book_heart: e.row.book_heart,
						like_subject: e.row.like_subject,
						like_book: e.row.like_book,
						interest: e.row.interest,
						
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name:'',
					is_content:-1,
					content:'',
					user_no:'',
				}
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			
			// 用戶狀態修改
			changeUserStatus(row) {
				const newStatus = row.status === 1 ? 0 : 1;
				
				// 如果是啟用操作，直接調用API
				if (newStatus === 1) {
					this.directEnableUser(row);
					return;
				}
				
				// 如果是禁用操作，顯示彈窗
				this.statusForm = {
					user_id: row.id,
					name: row.name,
					current_status: row.status,
					reason: ''
				};
				this.statusDialog = {
					visible: true,
					loading: false
				};
				
				// 清空表單驗證
				this.$nextTick(() => {
					if (this.$refs.statusForm) {
						this.$refs.statusForm.clearValidate();
					}
				});
			},
			
			// 直接啟用用戶
			directEnableUser(row) {
				this.$confirm('確認啟用該用戶嗎？', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					this.axios.post('/admin/data/editStatusUserInfo', {
						id: row.id,
						status: 1,
						reason: ''
					}, {
						token: true
					}).then(res => {
						if (res.data.code === 1) {
							// 更新本地數據
							row.status = 1;
							this.$message({
								message: '啟用成功',
								type: 'success'
							});
							// 刷新列表
							this.getList();
						} else {
							this.$message.error(res.data.msg || '操作失敗');
						}
					}).catch(err => {
						this.$message.error('操作失敗，請稍後重試');
					});
				}).catch(() => {
					// 用戶取消操作
				});
			},
			
			// 關閉狀態彈窗
			closeStatusDialog() {
				this.statusDialog.visible = false;
				this.statusForm = {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				};
			},
			
			// 確認狀態修改
			confirmStatusChange() {
				this.$refs.statusForm.validate((valid) => {
					if (valid) {
						this.statusDialog.loading = true;
						
						// 調用API修改狀態
						this.axios.post('/admin/data/editStatusUserInfo', {
							id: this.statusForm.user_id,
							status: 0,
							reason: this.statusForm.reason
						}, {
							token: true
						}).then(res => {
							if (res.data.code === 1) {
								// 更新本地數據
								const user = this.tableData.find(item => item.id === this.statusForm.user_id);
								if (user) {
									user.status = 0;
								}
								
								this.$message({
									message: '禁用成功',
									type: 'success'
								});
								
								// 刷新列表
								this.getList();
							} else {
								this.$message.error(res.data.msg || '操作失敗');
							}
							this.closeStatusDialog();
						}).catch(err => {
							this.$message.error('操作失敗，請稍後重試');
							this.closeStatusDialog();
						}).finally(() => {
							this.statusDialog.loading = false;
						});
					}
				});
			},
			
		}
	}
</script>

<style>
.user-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.user-info p {
  margin: 5px 0;
  color: #606266;
}

.dialog-footer {
  text-align: right;
}
</style>
